import { Schema } from '../../../data/dto/schema';

export const DispatchConfigSchema = {
    id: Schema.String,
    delivery_radius: Schema.Number,
    delivery_zone_model: Schema.String,
    delivery_zone_polyline: Schema.String,
    auto_assign: Schema.Boolean,
    allow_snooze: Schema.Boolean,
    driver_position_ids: Schema.Auto,
    max_orders: Schema.Number,
    offer_timeout_seconds: Schema.Number
};
